<template>
  <div>
    <page-toolbar height="100px">
      <vonap-toolbar-label label="Month">
        <kendo-datepicker
          :value="asOfDate"
          :format="'MMM yyyy'"
          :start="'year'"
          :depth="'year'"
          style="width:108px"
          @change="asOfDatePickerChanged"
        ></kendo-datepicker>
      </vonap-toolbar-label>
      <vonap-toolbar-label label="Analyst">
        <analyst-email v-model="analystEmail" @change="analystEmailChanged" />
      </vonap-toolbar-label>
      <vonap-toolbar-label label="Responsible">
        <responsible-email v-model="responsibleEmail" @change="responsibleEmailChanged" />
      </vonap-toolbar-label>
      <vonap-toolbar-label label="Client">
        <kendo-dropdownlist
          v-model="clientId"
          :data-source="clientDataSource"
          :data-text-field="'text'"
          :data-value-field="'value'"
          :filter="'contains'"
          @databound="onClientDataBound"
          @change="onClientChange"
          style="width:282px;"
        >
        </kendo-dropdownlist>
      </vonap-toolbar-label>
      <vonap-toolbar-label label="Component">
        <kendo-dropdownlist
          v-model="sendingMessageReportId"
          :data-source="componentDataSource"
          :data-text-field="'sendingMessageReportName'"
          :data-value-field="'sendingMessageReportId'"
          @change="componentDropDownChange"
          style="width:100px;"
        >
        </kendo-dropdownlist>
      </vonap-toolbar-label>
    </page-toolbar>
    <kendo-grid
      ref="grid"
      :height="'calc(100vh - 282px)'"
      :dataSource="gridDataSource"
      :autoBind="false"
      :filterable="true"
      :sortable="true"
      :pageable="false"
      :columns="gridColumns"
      :detail-init="detailInit"
      @databound="dataBound"
    >
    </kendo-grid>
  </div>
</template>
<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import PageToolbar from '@/components/PageToolbar'
import security from '@/mixins/security'
import notification from '@/helpers/notification'
import VonapToolbarLabel from '@/components/VonapToolbarLabel'
import AnalystEmail from '@/components/AnalystEmail'
import ResponsibleEmail from '@/components/ResponsibleEmail'
import {checkboxColumn, jsonDropDownEditor, readOnlyEditor} from '@/helpers/kendo-editors'
import {getDataItem} from '@/helpers/kendo-helpers'

export default {
  props: {
    editable: {type: Boolean, defaultValue: true},
  },
  name: 'DashboardTextResult',
  components: {
    PageToolbar,
    VonapToolbarLabel,
    AnalystEmail,
    ResponsibleEmail,
  },
  mixins: [security],
  mounted() {
    this.getData()
  },
  data() {
    return {
      asOfDate: null,
      responsibleEmail: 'ALL',
      analystEmail: 'ALL',
      clientId: -1,
      sendingMessageReportId: 5,
      gridDataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: false,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            type: 'GET',
            url: '/api/config/detOtherText/GetTextResultData',
            data: () => ({
              asOfDate: this.asOfDate,
              analystEmail: this.analystEmail,
              responsibleEmail: this.responsibleEmail,
              clientId: this.clientId,
              componentId: this.sendingMessageReportId,
            }),
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'component',
            fields: {
              component: {type: 'string'},
              client: {type: 'string'},
              analystEmail: {type: 'string'},
              responsibleEmail: {type: 'string'},
              language: {type: 'string'},
              text: {type: 'string'},
              source: {type: 'string'},
            },
          },
        },
      }),
      clientDataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        transport: {
          read: {
            type: 'GET',
            contentType: 'application/json',
            url: '/api/config/detOtherText/GetClientsData',
            data: () => ({
              analystEmail: this.analystEmail,
              responsibleEmail: this.responsibleEmail,
            }),
          },
        },
      }),
      componentDataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        transport: {
          read: {
            type: 'GET',
            contentType: 'application/json',
            url: '/api/report/monthlyReportSendingList/GetSendingMessageReport',
          },
        },
      }),
    }
  },
  methods: {
    async getData() {
      const request = await axios
        .get('/api/report/monthlyReportSendingList/getLastDate')
        .catch(() => notification('Error ', 'error'))
      let asOfDate = kendo.toString(request.data, 'yyyy-MM-dd')
      this.asOfDate = asOfDate
      this.refreshGrid()
    },
    asOfDatePickerChanged(e) {
      let asOfDate = kendo.toString(e.sender.value(), 'yyyy-MM-dd')
      this.asOfDate = asOfDate
      this.refreshGrid()
    },
    analystEmailChanged() {
      this.clientDataSource.read()
    },
    responsibleEmailChanged() {
      this.clientDataSource.read()
    },
    onClientDataBound(e) {
      e.sender.select(0)
      e.sender.trigger('change')
    },
    onClientChange({sender}) {
      this.clientId = +sender.value()
      this.refreshGrid()
    },
    componentDropDownChange({sender}) {
      this.sendingMessageReportId = +sender.value()
      this.refreshGrid()
    },
    refreshGrid() {
      return this.gridDataSource.read()
    },
    detailInit(e) {
      const {monthlyReportSendingListDetailId} = e.data
      kendo
        .jQuery('<div/>')
        .appendTo(e.detailCell)
        .kendoGrid({
          toolbar: ['create'],
          editable: 'inline',
          cancel: this.colorize,
          dataBound: this.colorize,
          dataSource: new kendo.data.DataSource({
            type: 'aspnetmvc-ajax',
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
            pageSize: 10,
            transport: {
              read: {
                type: 'GET',
                url: '/api/report/SendingMessage/grid',
                data: () => ({monthlyReportSendingListDetailId}),
                dataType: 'json',
              },
              create: {
                type: 'POST',
                url: '/api/report/SendingMessage/grid',
                data: () => ({monthlyReportSendingListDetailId}),
                complete: () => {
                  this.gridDataSource.read()
                },
                dataType: 'json',
              },
              update: {
                type: 'PUT',
                url: '/api/report/SendingMessage/grid',
                data: () => ({clientId: this.clientId}),
                dataType: 'json',
              },
              destroy: {
                type: 'DELETE',
                url: '/api/report/SendingMessage/grid',
                data: () => ({clientId: this.clientId}),
                dataType: 'json',
              },
            },
            schema: {
              errors: 'errors',
              total: 'total',
              data: 'data',
              model: {
                id: 'detOtherTextId',
                fields: {
                  detOtherTextId: {type: 'number', editable: false},
                  isShown: {type: 'boolean', defaultValue: true},
                  description: {type: 'string', validation: {required: true}},
                  amount: {type: 'number', defaultValue: null, validation: {required: false}},
                  ccy: {type: 'string', editable: true},
                  paramId: {type: 'number', defaultValue: 0},
                  paramName: {type: 'string', defaultValue: 'No Value'},
                },
              },
            },
          }),
          scrollable: false,
          sortable: false,
          pageable: true,
          columns: [
            {
              hidden: !this.isEditable,
              command: 'edit',
              title: '&nbsp;',
              width: 58,
            },
            checkboxColumn(
              'isShown',
              {
                title: 'Shown',
                width: 82,
              },
              !this.isEditable,
            ),
            {
              title: 'Description',
              field: 'description',
              width: 582,
              headerAttributes: {style: 'text-align: center;'},
              attributes: {style: 'text-align: left;'},
              editor(container, options) {
                const {model} = options
                if (model.isNew()) {
                  return jsonDropDownEditor(
                    'detOtherTextId',
                    'description',
                    '/api/report/SendingMessage/getMissingDetOtherTexts?monthlyReportSendingListDetailId=' +
                      monthlyReportSendingListDetailId,
                    {},
                    false,
                  ).call(this, container, options)
                }
                if (model.clientId === 0) {
                  return readOnlyEditor.call(this, container, options)
                }
                const input = kendo.jQuery(
                  `<input class="k-input k-textbox" name="${options.field}" required="required" />`,
                )
                input.appendTo(container)
              },
            },
            {
              template:
                '#= typeof clientId != "undefined" && clientId == 0 ? "Master" : "Client" #',
              title: 'Source',
              width: 100,
            },
            {
              command: [{name: 'destroy', visible: () => true}],
              width: 82,
              attributes: {style: 'text-align: center;'},
              hidden: !this.isEditable,
            },
            {},
          ],
        })
    },
    colorize: function(e) {
      setTimeout(() => {
        const rows = e.sender.tbody.children()
        for (let j = 0; j < rows.length; j++) {
          const row = kendo.jQuery(rows[j])
          const dataItem = getDataItem(row)
          const status = dataItem.get('status')
          row.addClass(status)
        }
      }, 100)
    },
    dataBound(event) {
      const $ = kendo.jQuery
      const grid = event.sender
      grid.tbody.children().each(function() {
        grid.expandRow($(this))
      })
    },
  },
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    gridColumns() {
      return [
        {
          field: 'component',
          title: 'Component',
          width: 110,
        },
        {
          field: 'client',
          title: 'Client',
          width: 182,
        },
        {
          field: 'analystEmail',
          title: 'Analyst',
          width: 182,
        },
        {
          field: 'responsibleEmail',
          title: 'Responsible',
          width: 182,
        },
        {
          field: 'language',
          title: 'Language',
          width: 114,
        },
        {},
      ].filter(c => c.editable !== false)
    },
    isEditable() {
      return !this.isReadOnly
    },
  },
}
</script>
